import React from 'react';
import * as Styled from './styled';
import { ArchivedReport } from '../../../models';
import { TableCell } from '@leasequery/lq.react-component-library/dist/components/table';
import Link from 'next/link';

interface ReportNameCellProps {
  cell: TableCell;
}

function ReportNameCell({ cell }: ReportNameCellProps): JSX.Element {
  const rowData = cell.row.original as ArchivedReport;
  return (
    <Link
      href="/results/[id]"
      as={`/results/${rowData.backgroundTaskId}`}
      passHref
      legacyBehavior
    >
      <Styled.ReportNameCell>{rowData.name}</Styled.ReportNameCell>
    </Link>
  );
}

export default ReportNameCell;
